import { render } from "./cookie-policy.vue?vue&type=template&id=55d2eed4&ts=true"
import script from "./cookie-policy.vue?vue&type=script&lang=ts"
export * from "./cookie-policy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__